/*global module*/
'use strict';

module.exports = function (poid) {
    var scrambled = new Array(10);

    function pad(poid, length) {
        var string = poid.toString();
        while (string.length < length) {
            string = '0' + string;
        }
        return string;
    }

    function digit(i) {
        return 9 - poid.charAt(i);
    }

    if (poid === null || isNaN(poid) || poid === '') {
        return '';
    }

    poid = pad(poid, 10);
    scrambled[0] = digit(8);
    scrambled[1] = digit(9);
    scrambled[2] = digit(4);
    scrambled[3] = digit(3);
    scrambled[4] = digit(2);
    scrambled[5] = digit(7);
    scrambled[6] = digit(6);
    scrambled[7] = digit(5);
    scrambled[8] = digit(0);
    scrambled[9] = digit(1);

    return scrambled.join('');
};